import { getMultiButtonCtaV4Template } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const multiButtonCtaV4Config = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Multi-Button CTA #4",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "colorinput",
          name: "bgOptionColor",
          label: "Option button color",
        },
        {
          type: "colorinput",
          name: "bgMainColor",
          label: "Main button color",
        },
      ],
    },
    initialData: {
      bgOptionColor: "#2377F8",
      bgMainColor: "#28B02B",
      openLink: "_self",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getMultiButtonCtaV4Template({
        url: data.url,
        count: data.count,
        tab: data.openLink,
        bgOptionColor: data.bgOptionColor,
        bgMainColor: data.bgMainColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { multiButtonCtaV4Config };
